export default __webpack_public_path__ + "static/media/s3.a6858506.png";